import requests from "./httpService";

const CoupanServices = {

    getCoupan: async () => {
        return requests.get(`/coupan`);
    },
    RevertgetCoupan: async () => {
        return requests.get(`/coupan/revert-history`);
    },
    RevertgetCoupanHistory: async (query = '') => {
        return requests.get(`/coupan/apply/user-history${query}`);
              

    },
    getMembershipCategories: async () => {
        return requests.get(`/membership-category`);
    },

    getActiveVendors: async () => {
        return requests.get(`/user/vendor/active`);
    },
    getVendorByServices: async (vendorId) => {
        return requests.get(`/service/vendor-service/${vendorId}`);
    },

    updateCoupanStatus: async (id, body) => {
        return requests.patch(`/coupan/status/${id}`, body);
    },

    createCoupan: async (body) => {

        return requests.post(`/coupan`, body);
    },

    deleteCoupan: async (id) => {
        return requests.delete(`/coupan/${id}`);
    },

    updateCoupon: async (id, body) => {
        return requests.patch(`coupan/coupan/${id}`, body);
    },


}
export default CoupanServices;